import './polyfills';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import './index.css'
import App from './App.jsx'

// Importar y aplicar la configuración de PDF
import { initPDFConfig } from './config/pdfConfig';

// Importar el servicio de verificación de actas pendientes
import { startApprovalCheckService } from './services/schedulerService';

// Inicializar la configuración de PDF
initPDFConfig();

// Iniciar el servicio de verificación de actas pendientes (cada 30 minutos en producción, cada 5 en desarrollo)
const intervalMinutes = import.meta.env.PROD ? 30 : 5;
startApprovalCheckService(intervalMinutes);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
)
